import BdcQueue from "../components/Bdc/Queue";

const BdcQueuePage = () => <BdcQueue />;

export default BdcQueuePage;
